import crudService from '../services/CrudService'
import { localStorageService } from '../services/LocalStorageService'

const crudStore = {
  namespaced: true,
  state: {
    list: [],
    selectedItem: null,
    selectedModule: null
  },
  mutations: {
    setList: (state, list) => {
      state.list = Array.from(list)
    },
    addItem: (state, item) => {
      state.list.unshift(item)
    },
    delete: (state, id) => {
      state.list = state.list.filter(item => item.id !== id)
    },
    selectItem: (state, item) => {
      state.selectedItem = item
    },
    selectModule: (state, module) => {
      state.selectedModule = module
    },
    updateStateSection: (state, newData) => {
      state.list.map(item => {
        if (item.id === newData.id) Object.assign(item.data, item.data)
      })
    }
  },
  actions: {
    async getItemById ({ commit }, data) {
      commit('selectItem', null)
      const item = await crudService(data.collection, data.id).getItemById()
      commit('selectItem', item)
      return item
    },
    async getList ({ commit }, data) {
      localStorageService.removeItem(data.collection)
      commit('setList', [])
      const list = await crudService(data.collection).getList()
      if (list.empty) return

      const listFormatted = list.docs.map((item) => {
        return { id: item.id, ...item.data() }
      })

      localStorageService.setItem(data.collection, listFormatted)

      commit('setList', listFormatted)
    },

    addToList: ({ commit }, item) => {
      commit('addItem', item)
    },

    getItem: ({ commit }, item) => {
      commit('selectItem', item)
    },

    deleteItem: async ({ commit }, data) => {
      await crudService(data.collection, data.item).deleteItem()
      commit('delete', data.item.id)
    },

    selectItem: ({ commit }, item) => {
      commit('selectItem', item)
    },

    createItem: async ({ dispatch }, data) => {
      const response = await crudService(data.collection, data.item).createItem()
      if (response) dispatch('addToList', response)
      return response
    },

    updateItem: async ({ dispatch, commit }, data) => {
      await crudService(data.collection, data.item).updateItem()
    },

    clearSelected: ({ commit }) => {
      commit('selectItem', null)
    }
  },
  getters: {
    selectedModule: state => state.selectedModule,
    selectedItem: state => state.selectedItem,
    listItems: state => state.list
  }
}

export default crudStore
